export default "__VITE_ASSET__87q6HKwg__"